import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { KibRadio } from '@chewy/kib-choices-react'
import { KibInputGroup } from '@chewy/kib-fields-react'
import { KibContainer } from '@chewy/kib-layout-react'
import { Utils } from '@pbt/pbt-ui-components'

import PatientInfoLabel from '~/components/common/labels/PatientInfoLabel'
import { getActivePatientsList } from '~/store/reducers/patients'
import { getUser } from '~/store/reducers/users'
import type { Prescription } from '~/types'

import styles from './SwapPatient.module.scss'

interface SwapProductDialogPatientProps {
  onChange: (patientId: string) => void
  prescription: Prescription
}

const SwapPatient = ({
  onChange,
  prescription,
}: SwapProductDialogPatientProps) => {
  const { t } = useTranslation('Dialogs')

  const [selectedItem, setSelectedItem] = useState<string | null>(null)

  const client = useSelector(getUser(prescription.clientId))
  const clientName = Utils.getPersonString(client)
  const patients = useSelector(getActivePatientsList(client?.patients)) || []

  const otherPatients = patients.filter(
    (patient) => patient.id !== prescription.patientId,
  )

  return (
    <KibContainer className={styles.wrapper}>
      <KibInputGroup
        label={
          <div className={styles.label}>
            {t('SWAP_PRODUCT_DIALOG.SELECT_OTHER_PATIENTS_LABEL', {
              clientName,
            })}
          </div>
        }
      >
        {otherPatients.map((patient) => (
          <div className={styles.radioItem} key={patient.id}>
            <KibRadio
              id={patient.id}
              label={
                <div className={styles.patientGrid}>
                  {patient.name && (
                    <div className={styles.patientName}>{patient.name}</div>
                  )}
                  <PatientInfoLabel patientId={patient.id} variant="body2" />
                </div>
              }
              name="radios"
              selectedValue={selectedItem}
              value={patient.id}
              onChange={(value) => {
                const newPatientId = value as string
                setSelectedItem(newPatientId)
                onChange(newPatientId)
              }}
            />
          </div>
        ))}
      </KibInputGroup>
    </KibContainer>
  )
}

export default SwapPatient
